<template>
  <div>
    <MainTable
      ref="mainTable"
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      :height="height"
      :headerText="$l('form_lable_factory_workshop_process')"
      @openEditDialog="openEditDialog"
      @change="tableChange"
    />
    <EditFormDialog
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :disabled="editFormDialogOptions.disabled"
      :data="editFormDialogOptions.data"
      :save-request="saveRequest"
    />
  </div>
</template>
<script>
import MainTable from './table'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditFormDialog from './edit-form'
export default {
  mixins: [TableAutoHeight],
  components: { MainTable, EditFormDialog },
  props: {
    workShopCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      editFormDialogOptions: {
        visible: false,
        title: '',
        disabled: false,
        data: {},
      },
    }
  },
  computed: {
    height() {
      return this.tableHeight - 58 < 400 ? 400 : this.tableHeight - 58
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.workShopCode) return
      this.loading = true
      const res = await this.$api
        .factoryWorkshopProcessListApi({ workShopCode: this.workShopCode })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    openEditDialog({ type, data = {} }) {
      const types = {
        add: this.$l('form_label_category_add') || '添加工厂车间工序信息',
        edit: this.$l('form_label_category_edit') || '编辑工厂车间工序信息',
        detail: this.$l('form_label_category_detail') || '工厂车间工序信息详情',
      }

      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        disabled: type === 'detail',
        data,
      }
    },
    async saveRequest(data) {
      if (!data) return false

      const $mainTable = this.$refs.mainTable

      const { _X_ID } = data
      const tableData = await $mainTable.getTableData()
      if (!_X_ID || !tableData || !tableData.length) {
        $mainTable.insert(data)
        return true
      }
      const index = tableData.findIndex((item) => item._X_ID === _X_ID)
      if (index >= 0) {
        $mainTable.spliceRow(index, data)
        return true
      }
      $mainTable.insert(data)
      return true
    },
    tableChange(data) {
      this.tableData = data
    },
    async getTableData() {
      return this.$refs.mainTable.getTableData()
    },
  },
}
</script>
